import styled from 'styled-components';
import { Header, Flexbox, GenericActionButton } from '@ibinder/ui-common-core';
import { Link } from 'react-router-dom';

export const TransparentActionButton = styled(GenericActionButton)`
  background: none !important;
`;

export const TransparentLinkButton = styled(Link)`
  opacity: ${(p: { disabled?: boolean }) => (!p.disabled ? 1 : 0.2)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  font-weight: bold;
`;

export const MenuRowWrapper = styled(Flexbox)`
  width: 100%;
`;

export const MenuRow = styled(Flexbox)<{ useDefaultCursor?: boolean }>`
  cursor: ${({ useDefaultCursor }) => (useDefaultCursor ? 'auto' : 'pointer')};
  a {
    display: flex;
    align-items: center;
  }

  @media (max-width: ${(p) => p.theme.devices.sm}px) {
    max-width: 100%;
  }
  svg {
  }
  align-items: center;
  &:first-of-type {
    border-bottom: 1px solid ${(p) => p.theme.colors.discrete50};
  }
`;

export const ProfileInformation = styled.span`
  margin: 0.8125rem;
  a {
    display: flex;
    flex-direction: column;
    align-items: start;
  }
`;
